import * as React from "react";
const SvgRename = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width={11} height={11} {...props}>
    <path d="M4.976 1.049v1.177H1.563a.386.386 0 0 0-.386.386v6.825c0 .213.173.386.386.386h6.825a.386.386 0 0 0 .386-.386V6.024h1.177v3.413c0 .863-.7 1.563-1.563 1.563H1.563C.7 11 0 10.3 0 9.437V2.612C0 1.75.7 1.05 1.563 1.05z" />
    <path d="M8.205.48a1.637 1.637 0 0 1 2.315 2.315l-4.63 4.63a.6.6 0 0 1-.28.16l-1.95.487a.603.603 0 0 1-.732-.732l.488-1.95a.6.6 0 0 1 .158-.28zm1.462.853a.43.43 0 0 0-.609 0L4.545 5.845l-.203.812.813-.203 4.512-4.512a.43.43 0 0 0 .056-.542z" />
  </svg>
);
export default SvgRename;

